// import store from '@/store/index.js'
// let dic = store.state.dic;

export default function Configs(that) {

    const searchItems = [
        {
            label: "身份证号",
            span: 5,
            placeholder: '请输入身份证号',
            model: "11",
        },
        {
            label: "姓名",
            span: 5,
            placeholder: '请输入姓名',
            model: "22",
            type: "select",
        },
        {
            label: "学号",
            prop: "studentNo",
            span: 5,
            placeholder: '请输入学号',
            model: "33",
        },
        {
            label: "报到状态",
            span: 5,
            placeholder: '请选择报到状态',
            model: "44",
            type:'select'
        },
        {
            label: "请假状态",
            span: 4,
            placeholder: '请选择请假状态',
            model: "55",
            type:'select'
        },
        {
            label: "学院",
            span: 5,
            placeholder: '请选择学院',
            model: "66",
            type: "select",
        },
        {
            label: "系别",
            span: 5,
            placeholder: '请选择系别',
            model: "77",
            type: "select",
        },
        {
            label: "专业",
            span: 5,
            placeholder: '请选择专业',
            model: "88",
            type: "select",
        },
        {
            label: "班级",
            span: 5,
            placeholder: '请选择班级',
            model: "99",
            type: "select",
        },
        {
            label: "备注",
            span: 4,
            placeholder: '请输入备注',
            model: "100",
        },
        
    ]
    const tableColumns = [
        {
            label: "身份证号",
            prop: "11",
            align: "center",
            show: true
        },
        {
            label: "姓名",
            prop: "22",
            align: "center",
            show:true
        },
        {
            label: "学号",
            prop: "studentNo",
            align: "center",
            show:true
        },
        {
            label: "性别",
            prop: "44",
            align: "center",
            show:true
        },
        {
            label: "学院",
            prop: "55",
            align: "center",
            show:true
        },
        {
            label: "系别",
            prop: "66",
            align: "center",
            show:true
        },
        {
            label: "专业",
            prop: "77",
            align: "center",
            show: true
        },
        {
            label: "班级",
            prop: "88",
            align: "center",
            show: true
        },
        {
            label: "报到状态",
            prop: "99",
            align: "center",
            // width:'150px',
            show:true
        },
        {
            label: "请假状态",
            prop: "100",
            align: "center",
            show: true
        },
        {
            label: "备注",
            prop: "101",
            align: "center",
            // width:'150px',
            show:true
        },
        {
            label: "操作",
            name: "custom",
            align: "center",
            width:'260px',
            show:true
          }
    ]
    const formItems1 = [
        {
            label: "身份证号",
            span: 12,
            placeholder: '请输入身份证号',
            model: "id",
        },
        {
            label: "学号",
            prop: "studentNo",
            span: 12,
            placeholder: '请选择编号',
            type: 'select',
            model: "11",
        },
        {
            label: "姓名",
            span: 12,
            disabled:true,
            model: "12",
        },
        {
            label: "性别",
            span: 12,
            model: "13",
            disabled:true,
        },
        {
            label: "学院",
            span: 12,
            model: "14",
            disabled:true,
        },
        {
            label: "系别",
            span: 12,
            model: "15",
            disabled:true,
        },
        {
            label: "专业",
            span: 12,
            model: "15",
            disabled:true,
        },
        {
            label: "班级",
            span: 12,
            model: "15",
            disabled:true,
        },
        {
            label: "请假状态",
            span: 12,
            model: "15",
            type:'select',
            placeholder: '请选择请假状态',
        },
        {
            label: "备注",
            span: 24,
            model: "15",
            type:'textarea',
        },
    ]

    const formItems2 = [
        {
            label: "身份证号",
            span: 24,
            placeholder: '请输入身份证号',
            model: "id",
            disabled:true,
        },
        {
            label: "请假状态",
            span: 24,
            model: "15",
            type:'select',
            placeholder: '请选择请假状态',
        },
        {
            label: "备注",
            span: 24,
            model: "15",
            type:'textarea',
        },
    ]

    const formRules = {
        // 11: [{
        //     required: true,
        //     message: "请输入名称",
        //     trigger: "blur"
        // }],
        // 22: [{
        //     required: true,
        //     message: "请选择年度",
        //     trigger: "blur"
        // }],
        // 33: [{
        //     required: true,
        //     message: "请选择时间",
        //     trigger: "blur"
        // }],
        // 44: [{
        //     required: true,
        //     message: "请选择展示方式",
        //     trigger: "blur"
        // }],
        // 55: [{
        //     required: true,
        //     message: "请选择院系评议时间",
        //     trigger: "blur"
        // }],
        // 66: [{
        //     required: true,
        //     message: "请选择状态",
        //     trigger: "blur"
        // }],
    }
    return {
        searchItems,
        tableColumns,
        formItems1,
        formItems2,
        formRules
    }
}
